'use strict';
var page = document.querySelector('.baseline-menu');
var switcher = document.querySelector('.page__header');
var switcher2 = document.querySelector('.page__main');
function toggleOpacity() {
    page.classList.toggle('baseline-opacity');
    switcher.classList.toggle('page__header--opacity');
    switcher2.classList.toggle('page__main--opacity');
}
var toggleElements = [
    page,
    document.querySelector('.baseline-close--tablet'),
    document.querySelector('.baseline-close--phone'),
    document.querySelector('.page__menu-section--first--element--a-gal'),
    document.querySelector('.page__menu-section--first--element--a-eve'),
    document.querySelector('.page__menu-section--first--element--a-gal-lec'),
    document.querySelector('.page__menu-section--first--element--a-gal-cont')
];
toggleElements.forEach(function(el) {
    if (el) el.addEventListener('click', toggleOpacity);
});
var currentSlide = 0;
var bullets = document.querySelectorAll('.page__main-section--gallery--slider-buttons--bullet');
function updateSlider(index) {
    bullets.forEach(function(bullet) {
        return bullet.classList.remove('page__main-section--gallery--slider-buttons--bullet-active');
    });
    bullets[index].classList.add('page__main-section--gallery--slider-buttons--bullet-active');
}
function changeSlide(index) {
    updateSlider(index);
}

//# sourceMappingURL=Museum.ff46ce06.js.map
